import { useEffect, useState } from 'react';
import { useAuth } from '../../../contexts/authContext';
import { hasAccess, Roles } from '../../../helpers/access';
import PrimaryButton from '../buttons/primaryButton';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import InputScoreDialog from '../../score/inputScoreDialog';
import { useDispatch, useSelector } from 'react-redux';
import { getEvent } from '../../../features/event/eventSlice';
import gameFormatService from '../../../features/gameFormat/gameFormatService';

const ScoreButton = ({ game }) => {
  const [scoreWayOpen, setScoreWayOpen] = useState(false);
  const { authenticated, currentUserProfile, currentUser } = useAuth();
  const gameScorer = game.scorer?.id || game.scorer;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const selectedEvent = useSelector((state) => state.event.event);
  useEffect(() => {
    if (!selectedEvent && game) {
      dispatch(getEvent(game.event));
    }
  }, [selectedEvent, game, dispatch]);

  const handleCloseScoreWay = () => {
    setScoreWayOpen(false);
  };

  return game.status === gameFormatService.GameStatus.IN_PROGRESS ||
    game.status === gameFormatService.GameStatus.PLAYOFF ? (
    <>
      {hasAccess(currentUserProfile, Roles.SCORER) ||
      (currentUser && currentUser.uid === gameScorer) ? (
        <PrimaryButton color="success" variant="contained" onClick={() => setScoreWayOpen(true)}>
          Score Game
        </PrimaryButton>
      ) : null}

      <Dialog open={scoreWayOpen} onClose={handleCloseScoreWay} fullWidth maxWidth="sm">
        <DialogTitle>Score Game</DialogTitle>
        <DialogContent>
          <DialogContentText> How would you like to score the game.</DialogContentText>
        </DialogContent>
        <DialogActions sx={{ m: 2 }}>
          <Button onClick={handleCloseScoreWay} color="primary">
            Cancel
          </Button>

          {hasAccess(currentUserProfile, Roles.SCORER) ||
          (currentUser && currentUser.uid === gameScorer) ? (
            <>
              {!selectedEvent?.liveScoreOnly && (
                <InputScoreDialog game={game} onOpen={() => setScoreWayOpen(false)} />
              )}

              <Button
                variant="contained"
                onClick={() => navigate(`/game/scoring/${game.id}`)}
                color="primary">
                Score Live
              </Button>
            </>
          ) : null}
        </DialogActions>
      </Dialog>
    </>
  ) : null;
};

export default ScoreButton;
